import React from 'react';
import type { ReactNode } from 'react';
import { Box } from 'ink';
import { isType, match } from 'variant';
import { Text } from '../Text.js';
import { SelectOptionAvailability } from './types.js';
import type { SelectOption } from './types.js';

interface Props<T> {
  isSelected?: boolean;
  label: ReactNode;
  value: SelectOption<T>;
}

export function Item<T>({
  isSelected,
  label,
  value: { description, availability = SelectOptionAvailability.Enabled() },
}: Props<T>) {
  const isDisabled = isType(availability, SelectOptionAvailability.Disabled);

  return (
    <Box>
      <Text
        skin={isDisabled ? 'secondary' : isSelected ? 'info' : 'standard'}
        strikethrough={!isSelected && isDisabled}
      >
        {label}
      </Text>
      {isSelected &&
        match(availability, {
          Disabled: ({ reason }) => (
            <Box marginLeft={1}>
              {reason ? (
                <Text skin="warning">- disabled ({reason})</Text>
              ) : (
                <Text skin="warning">- disabled</Text>
              )}
            </Box>
          ),
          Enabled: () =>
            description && (
              <Box marginLeft={1}>
                <Text skin="secondary">- {description}</Text>
              </Box>
            ),
        })}
    </Box>
  );
}
